import {Component, OnInit} from '@angular/core';
import {SessionService} from "../../platform/base/services/session.service";
import {HttpClient} from "@angular/common/http";
import {Overlay} from "@angular/cdk/overlay";
import {MatDialog, MatDialogRef} from "@angular/material/dialog";
import {ActivatedRoute} from "@angular/router";
import {Callback, IErrorObject} from "../../../../types/platform/universe";
import {VideoDialogComponent} from "./video-dialog/video-dialog.component"

import {environment} from '../../../environments/environment';
import {SessionableComponent} from "../../platform/base/components/sessionable.component";
import {TranslateService} from "@ngx-translate/core";

@Component({
	selector: 'app-staticvideo',
	templateUrl: './staticvideo.component.html',
	styleUrls: ['./staticvideo.component.css']
})
export class StaticvideoComponent extends SessionableComponent implements OnInit {

	public results: any[] = [];
	public filename: string = "";
	public size: number = 20;
	public count: number = 0;

	public breakpoint: number = 4;
	public breakpoint_rh: string = "1:1";
	public gutter: string = "10px";
	public resizeThreshold: any;

	public params: any = {};

	protected query: object = {};
	protected page: number = 0;

	public all_videos: any[];

	constructor(
		protected session: SessionService,
		protected http: HttpClient,
		private overlay: Overlay,
		private matDialog: MatDialog,
		protected route: ActivatedRoute,
		public translate: TranslateService
	) {
		super(session);
		this.resizeThreshold = {width: 1000, height: 1000};
		this.all_videos = environment.video_layout;
	}

	public VideoRowsByType(type: number): any[] {
		return this.all_videos[type].row;
	}

	public RowNameByType(type: number): string[] {
		return this.translate.instant(this.all_videos[type].name);
	}

	public translateOne(S:string):string {
		return this.translate.instant(S);
	}

	public VideoSubCategoriesByIndex(row: any, index: number): any[] {
		return row.sub_categories;
	}

	public VideoColumnsByIndex(sub_categories: any, index: number): any[] {
		return sub_categories.column;
	}

	public ColumnNameByIndex(row: any, index: number): string {
		return this.translate.instant(row.name);
	}

	/**
	 *
	 * @param width
	 */
	private widthToColumns(width: number): number {
		let result: number = 4;
		if (width < 600) {
			result = 1;  // xs,
		} else if (width < 960) {
			result = 2;  // sm,
		} else if (width < 1280) {
			result = 4;  // md,
		}
		return result;
	}

	/**
	 *
	 * @param width
	 */
	private widthToRatio(width: number): string {
		let result: string = "1:1";
		if (width < 600) {
			result = "2:1";  // xs,
		} else if (width < 960) {
			result = "1:1";  // sm,
		} else if (width < 1280) {
			result = "1:1";  // md,
		}
		return result;
	}

	/**
	 *
	 * @param width
	 */
	private widthToGutter(width: number): string {
		let result: string = "10px";
		if (width < 600) {
			result = "-30px";
		}
		return result;
	}


	public ngOnInit(): void {
		this.page = 0;
		this.query = {};

		this.breakpoint = this.widthToColumns(window.innerWidth);
		this.breakpoint_rh = this.widthToRatio(window.innerWidth);
		this.gutter = this.widthToGutter(window.innerWidth);
		this.route.queryParams.subscribe(params => {
			this.params = params;
		});
		this.getSession((error: IErrorObject, session: object): void => {
			if (!error) {

			}
		})
	}

	/**
	 *
	 */
	public onResize(event: any): void {
		this.breakpoint = this.widthToColumns(event.target.innerWidth);
		this.breakpoint_rh = this.widthToRatio(event.target.innerWidth);
		this.gutter = this.widthToGutter(event.target.innerWidth);
	}

	/**
	 *
	 */
	public thumbnail(file:any): string {
		let result: string = ""
		if (file) {
			if (file.thumbnail) {
				result = file.thumbnail;
			}
		}
		return result;
	}

	/**
	 *
	 */
	public onVideo(file: any): void {
		this.videoDialog(file, (error: IErrorObject, result: any): void => {
			if (!error) {
			}
		})
	}

	/**
	 *
	 */
	public videoDialog(file: any, callback: Callback<any>): void {
		const dialog: MatDialogRef<any> = this.matDialog.open(VideoDialogComponent, {
			width: "80%",
			minWidth: "320px",
			height: "fit-content",
			panelClass: "dark-card",
			data: {
				session: this.currentSession,
				content: file,
			},
			disableClose: true,
		});

		dialog.afterOpened().subscribe((result: any): void => {

		});

		dialog.beforeClosed().subscribe((result: any): void => {
			if (result) { // if not cancel then
				callback(null, result.content.file);
			}
		});

		dialog.afterClosed().subscribe((result: any): void => {
			if (result) {
				this.Complete("", result);
			}
		});
	}

}
